export const RouteConstant = {
  auth: {
    home: {
      path: "/home",
      name: "home",
    },
    login: {
      path: "/login",
      name: "login",
    },
    signup: {
      path: "/signup",
      name: "signup",
    },
    otp: {
      path: "/otp",
      name: "otp",
    },
    invite: {
      path: "/invite",
      name: "invite",
    },
    error: {
      path: "/error",
      name: "error",
    },
    projects: {
      path: "/projects",
      name: "projects",
    },
    success: {
      path: "/success",
      name: "success",
    },
    successSignup: {
      path: "/success-signup",
      name: "success-signup",
    },
    successReset: {
      path: "/success-reset",
      name: "success-reset",
    },
    created: {
      path: "/created",
      name: "created",
    },
    changed: {
      path: "/changed",
      name: "changed",
    },
    reset: {
      path: "/reset",
      name: "reset",
    },
    resetPassword: {
      path: "/reset-password",
      name: "reset-Password",
    },
    changePassword: {
      path: "/change-password",
      name: "change-Password",
    },
    terms: {
      path: "/terms",
      name: "terms",
    },
    contact: {
      path: "/contact-us",
      name: "contact",
    },
  },
  dashboard: {
  
    dashboard: {
      path: "/dashboard",
      name: "dashboard",
    },
    integration: {
      path: "/integration",
      name: "Integration",
    },
    billing: {
      path: "/billing",
      name: "billing",
    },
    applicationWorkspace: {
      path: "/applicationWorkspace",
      name: "applicationWorkspace",
    },
    entity: {
      path: "/entity",
      name: "entity",
    },
    attribute: {
      path: "/attribute",
      name: "attribute",
    },
    createWorkspace: {
      path: "/create-workspace",
      name: "Create Workspace",
    },
    workspace: {
      path: "/workspace",
      name: "Workspace",
    },
    inviteTeamMember: {
      path: "/invite-team-member",
      name: "Invite Team Member",
    },
  },
};

export const homeRoutes = {
  navRoutes: [
    {
      id: "solutions",
      path: "/solutions",
      name: "Solutions",
    },
    {
      id: "pricing",
      path: "/pricing",
      name: "Pricing",
    },
    {
      id: "testimonials",
      path: "/testimonials",
      name: "Testimonials",
    },
    {
      id: "support",
      path: "/contact-us",
      name: "Support",
    },
    {
      path: "/terms",
      name: "Terms & Conditions",
    },
    {
      path: "/contact-us",
      name: "Help",
    },

  ],
  auth: {
    login: {
      name: "Login",
      path: "/login",
    },
    signup: {
      name: "Sign Up",
      path: "/signup",
    },
    forgotPassword: {
      name: "Forgot Password",
      path: "/forgot-password",
    },
    resetPassword: {
      name: "Reset Password",
      path: "/reset-password",
    },
    register: {
      name: "",
      path: "/register",
    },
    getStarted: {
      path: "/get-started",
      name: "Get Started Screen",
      moduleName: "authentication",
    },
  },
};
